<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Dashboard</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li aria-current="page" class="breadcrumb-item active">Library</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex no-block align-items-center">
                                <div>
                                    <h6 class="text-muted font-16">TOTAL PURCHASES</h6>
                                    <h4 class="text-cyan font-weight-bold" v-if="purchases">{{purchases | money}}</h4>
                                    <h4 class="text-cyan font-weight-bold" v-else>0.00</h4>
                                </div>
                                <div class="ml-auto">
                                    <span class="text-cyan display-6"><i class="fa fa-cart-arrow-down"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex no-block align-items-center">
                                <div>
                                    <h6 class="text-muted font-16">TOTAL SALES</h6>
                                    <h4 class="text-indigo" v-if="sales">{{sales | money}}</h4>
                                    <h4 class="text-indigo" v-else>0.00</h4>
                                </div>
                                <div class="ml-auto">
                                    <span class="text-indigo btn-circle display-6"><i
                                            class="fa fa-credit-card"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex no-block align-items-center">
                                <div>
                                    <h6 class="text-muted font-16"> TOTAL OFFER VALUE</h6>
                                    <h4 class="text-brown" v-if="offer_values">{{offer_values | money}}</h4>
                                    <h4 class="text-brown" v-else>0.00</h4>
                                </div>
                                <div class="ml-auto">

                                    <span class="text-brown display-6"><i aria-hidden="true"
                                                                          class="fa fa-hand-holding-usd"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex no-block align-items-center">
                                <div>
                                    <h6 class="text-muted font-16">TOTAL TRADE VALUE</h6>
                                    <h4 class="text-dark-green" v-if="trade_values">{{trade_values | money}}</h4>
                                    <h4 class="text-dark-green" v-else>0.00</h4>
                                </div>
                                <div class="ml-auto">
                                    <span class="text-dark-green display-6"><i class="fa fa-handshake"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-md-flex align-items-center">
                                <h4 class="card-title">Trade Overview</h4>
                            </div>
                            <div class="row position-relative" v-if="!isBarLoading">
                                <apexchart :options="chartOptions" :series="bar_series" height="240" type="bar"
                                           width="240"></apexchart>
                            </div>
                            <div class="card-body" v-else>
                                <div class="spinner-border text-primary text-center p-4" role="status" style="margin-left: 70px"></div>
                            </div>
                            <ul class="list-style-none" v-if="!isBarLoading">
                                <li>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <h6 class="m-b-0 font-bold"><span class="font-light">Trade Completed</span>
                                            </h6>
                                        </div>
                                        <div class="ml-auto">
                                            <h6 class="m-b-0 font-bold">{{trade_completed}}%</h6>
                                        </div>
                                    </div>
                                    <div class="progress">
                                        <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="89"
                                             class="progress-bar bg-success" role="progressbar"
                                             :style="'width:'+ trade_completed+'%'"></div>
                                    </div>
                                </li>
                                <li class="m-t-25">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <h6 class="m-b-0 font-bold"> <span
                                                    class="font-light">Trade In Progress</span></h6>
                                        </div>
                                        <div class="ml-auto">
                                            <h6 class="m-b-0 font-bold">{{trade_inprogress}}%</h6>
                                        </div>
                                    </div>
                                    <div class="progress">
                                        <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="79"
                                             class="progress-bar bg-success" role="progressbar"
                                             :style="'width:'+ trade_inprogress+'%'"></div>
                                    </div>
                                </li>
                                <li class="m-t-25">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <h6 class="m-b-0 font-bold"><span
                                                    class="font-light">Trade In Draft</span>
                                            </h6>
                                        </div>
                                        <div class="ml-auto">
                                            <h6 class="m-b-0 font-bold">{{trade_draft}}%</h6>
                                        </div>
                                    </div>
                                    <div class="progress">
                                        <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="49"
                                             class="progress-bar bg-success" role="progressbar"
                                             :style="'width:'+ trade_draft+'%'"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-md-flex align-items-center">
                                <div>
                                    <h4 class="card-title">Production Report</h4>
                                    <h5 class="card-subtitle">Quarterly Progress</h5>
                                </div>
                                <div class="ml-auto d-flex align-items-center">
                                    <div class="dl">
                                        <select class="custom-select" v-model="selected_production_item">
                                            <option :value="item" v-for="item in production_items">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="dl ml-1">
                                        <select class="custom-select" v-model="selected_year">
                                            <option :value="item" v-for="item in years">{{item}}</option>
                                        </select>
                                    </div>
                                    <div class="dl ml-1">
                                        <select class="custom-select" v-model="selected_catalog">
                                            <option :value="item" v-for="item in catalog_names">{{item}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-t-20">
                                <div class="net-income position-relative" style="height:220px;" v-if="isLoading">
                                    <div>
                                        <apexchart :options="options" :series="series" height="230" type="line"
                                                   width="520"></apexchart>
                                    </div>
                                </div>
                                <div class="card-body" v-else>
                                    <div class="spinner-border p-5 text-primary text-center" role="status"
                                         style="margin-left: 150px"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- column -->
                        <div class="col-sm-12 col-lg-4">
                            <div class="card custom-bg-success">
                                <div class="card-body">
                                    <div class="custom-d-flex">
                                        <div class="m-r-10">
                                            <h4 class="text-dark-green">Total Contract Value</h4>
                                            <h4 class="text-dark-green font-20">{{contract_value | money}}</h4>
                                        </div>
                                        <div class="ml-auto">
                                            <div class="m-b-40" style="max-width:130px; height:15px;">
                                                <canvas id="balance"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- column -->
                        <div class="col-sm-12 col-lg-4">
                            <div class="card custom-bg-info">
                                <div class="card-body">
                                    <div class="custom-d-flex align-items-center">
                                        <div class="m-r-10">
                                            <h4 class="text-info">Draft Contracts</h4>
                                            <h4 class="text-info font-20">{{contract_draft}}</h4>
                                        </div>
                                        <div class="ml-auto">
                                            <div class="" id="ravenue">
                                                <canvas height="55"
                                                        style="display: inline-block; width: 76px; height: 55px; vertical-align: top;"
                                                        width="76"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- column -->
                        <div class="col-sm-12 col-lg-4">
                            <div class="card custom-bg-grey">
                                <div class="card-body">
                                    <div class="custom-d-flex align-items-center">
                                        <div class="m-r-10">
                                            <h4 class="text-brown">Confirmed Contracts</h4>
                                            <h4 class="text-brown font-20">{{contract_confirmed}}</h4>
                                        </div>
                                        <div class="ml-auto">
                                            <div class="gaugejs-box">
                                                <canvas class="gaugejs" height="50" id="foo" width="100">guage</canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-lg-3">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Recent Activity</h4>
                        </div>
                            <div class="comment-widgets scrollable ps-container ps-theme-default ps-active-y" style="height:380px;">
                                <ul class="list-unstyled">
                                    <li @click="toContext(e.id, e.visibility, e.context, e.context_props)"
                                        class="media d-flex flex-row comment-row m-t-0" style="cursor: pointer"
                                        v-bind:key="index"
                                        v-for="(e, index) in events">
                                        <div class="d-flex align-items-center">
                                            <div class="m-r-10">
                                                <span class="btn-md btn-outline-success"
                                                      v-if="e.context === 'trade'">
                                                    <i class="fas fa-handshake"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-cyan"
                                                      v-if="e.context === 'purchase'">
                                                    <i class="fas fa-cart-arrow-down"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-primary"
                                                      v-if="e.context === 'sale'">
                                                    <i class="fas fa-credit-card"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-orange"
                                                      v-if="e.context === 'invoice'">
                                                    <i class="fas fa-money-bill-alt"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-tumblr"
                                                      v-if="e.context === 'Partner'">
                                                <i class="fas fa-user-plus"></i>
                                            </span>
                                            </div>
                                        </div>
                                        <div class="media-body">
                                            <h5 class="mt-0 mb-1">{{e.name}}</h5>
                                            <span :title="e.desc" class="text-muted">{{e.desc | truncate(50, '....')}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'Dashboard2',
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        watch: {
            selected_production_item: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.isLoading = false;
                    setTimeout(() => {
                        let self = this;
                        let productions = this.productions.filter(p => p.item === newVal && p.year === self.selected_year && p.catalog === self.selected_catalog);
                        productions = productions.sort(function (a, b) {
                            return Number(a.quantity.x.substring(1)) - Number(b.quantity.x.substring(1))
                        });
                        this.series[0].data = productions.map(p => p.quantity);
                        this.isLoading = true;
                    }, 1)
                }
            },
            selected_year: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.isLoading = false;
                    setTimeout(() => {
                        let self = this;
                        let productions = this.productions.filter(p => p.year === newVal && p.item === self.selected_production_item && p.catalog === self.selected_catalog);
                        productions = productions.sort(function (a, b) {
                            return new Date(a.date) - new Date(b.date)
                        });
                        this.series[0].data = productions.map(p => p.quantity);
                        this.isLoading = true;
                    }, 1)
                }
            },
            selected_catalog: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.isLoading = false;
                    setTimeout(() => {
                        let self = this;
                        let productions = this.productions.filter(p => p.year === self.selected_year && p.item === self.selected_production_item && p.catalog === newVal);
                        productions = productions.sort(function (a, b) {
                            return new Date(a.date) - new Date(b.date)
                        });
                        this.series[0].data = productions.map(p => p.quantity);
                        this.isLoading = true;
                    }, 1)
                }
            }
        },
        data: function () {
            return {
                production_items: [],
                selected_production_item: null,
                selected_year: null,
                selected_catalog: null,
                productions: [],
                years: [],
                catalog_names: [],
                catalogs: [],
                chartOptions: {
                    series: [{
                        name: 'series-1',
                        data: []
                    }],
                    colors: ['#019b40'],
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        type: 'bar',
                        toolbar: {
                            show: true,
                            tools: {
                                download: false
                            }
                        }
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            show: true
                        }
                    },
                    yaxis: {
                        title: {
                            text: `Trade Value`
                        }
                    }

                },
                bar_series: [{
                    name: 'Trade Value',
                    data: []
                }],
                series: [{
                    name: 'Estimated Yield(MT)',
                    data: []
                }],
                options: {
                    series: [{
                        name: "Desktops",
                        data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
                    }],
                    chart: {
                        height: 250,
                        type: 'line',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: true,
                            tools: {
                                download: false
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        },
                    },
                    xaxis: {
                        categories: ['Q1', 'Q2', 'Q3', 'Q4'],
                        title: {
                            text: 'Period'
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Estimated Yield (MT)'
                        }
                    }
                },
                calls: [],
                claims: [],
                isLoading: false,
                isBarLoading: true,
                total_dids: 0,
                total_yield: 0,
                purchases: null,
                sales: null,
                trade_values: null,
                offer_values: null,
                is_bws_token_exist: false,
                events: [],
                trade_draft: 0,
                trade_inprogress: 0,
                trade_completed: 0,
                contract_draft: 0,
                total_contract: 0,
                contract_confirmed: 0,
                contract_value: 0
            }
        },
        mounted() {
            console.log(this.currentOrg);
            this.is_bws_token_exist = JSON.stringify(localStorage.getItem('bws_token')) !== 'null' ? true : false;
            if (this.is_bws_token_exist) {
                this.init();
            } else {
                this.isLoading = true;
                this.options.xaxis.title.text = '';
                this.options.yaxis.title.text = ''
            }
            this.getOverview();
        },
        methods: {
            async init() {
                try {
                    this.isLoading = false;
                    await this.getCatalogs();
                    await this.getDids();
                    await this.prepareProductionData();
                } catch (e) {
                } finally {
                    this.isLoading = true;
                }
                $(".preloader").fadeOut();
            },
            async getOverview() {
                await Promise.all([
                    this.totalPurchases(),
                    this.totalSales(),
                    this.totalOfferValues(),
                    this.totalTradeValues(),
                    this.getAllEvents(),
                    this.getTradeOverview(),
                    this.getContractOverview()
                ])
            },
            async totalSales() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalSales`);
                    this.sales = response.data;
                } catch (e) {
                    this.$toastr('error', 'Failed to fetch sales summary', 'Failed')
                }
            },
            async totalPurchases() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalPurchases`);
                    this.purchases = response.data;
                } catch (e) {
                    this.$toastr('error', 'Failed to fetch purchases summary', 'Failed')
                }
            },
            async totalOfferValues() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalOfferPrice`);
                    this.offer_values = response.data;
                } catch (e) {
                    this.$toastr('error', 'Failed to fetch purchases summary', 'Failed')
                }
            },
            async totalTradeValues() {
                try {
                    let response = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/totalTradeValue`);
                    this.trade_values = response.data;
                } catch (e) {
                    this.$toastr('error', 'Failed to fetch purchases summary', 'Failed')
                }
            },
            async getAllEvents() {
                let reply = await this.$http.get(`notifications/all`, {
                    params: {
                        page: 1,
                        perPage: 1000
                    }
                });
                this.events = reply.data.events;
            },
            async getTradeOverview() {
                try {
                    this.isBarLoading = true;
                    this.chartOptions.yaxis.title.text = `Trade value in ${this.currentOrg ? this.currentOrg.currency_symbol : ''}`
                    let {data} = await this.$http.get("/trades/overview");
                    this.bar_series[0].data = data.overview.map(o => ({
                        x: o.name,
                        y: parseInt(o.total)
                    }));
                    this.bar_series[0].name = `Trade Value (${this.currentOrg ? this.currentOrg.currency_symbol : ''})`;
                    let total_trade = data.status.map(item => item.count).reduce((prev, next) => Number(prev) + Number(next));
                    let trade_completed = data.status.find(s=> s.status === 'COMPLETE');
                    trade_completed = trade_completed ? Number(trade_completed.count) : 0;
                    let trade_draft = data.status.find(s=> s.status === 'OPEN');
                    trade_draft = trade_draft ? Number(trade_draft.count) : 0;
                    let trade_inprogress = data.status.find(s=> (['ACCEPTED', 'SIGNED']).includes(s.status));
                    trade_inprogress = trade_inprogress ? Number(trade_inprogress.count) : 0;
                    this.trade_completed = Math.round((trade_completed / total_trade) * 100);
                    this.trade_draft = Math.round((trade_draft / total_trade) * 100);
                    this.trade_inprogress = Math.round((trade_inprogress / total_trade) * 100);
                } catch (e) {
                    console.log(e)
                } finally {
                    this.isBarLoading = false;
                }
            },
            async getContractOverview(){
                try {
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/overview`);
                    this.total_contract = data.status.map(item => item.count).reduce((prev, next) => Number(prev) + Number(next));
                    let contract_draft = data.status.find(s=> s.status === 'DRAFT');
                    this.contract_draft = contract_draft ? contract_draft.count : 0;
                    let contract_confirmed = data.status.find(s=> s.status === 'CONFIRMED');
                    this.contract_confirmed = contract_confirmed ? contract_confirmed.count : 0;
                    this.contract_value = data.contract_value;
                }catch (e) {

                }
            },
            toContext(eventid, visibility, context, context_props) {
                switch (context) {
                    case 'trade':
                        this.$router.push({name: "viewtrade", params: {tradeid: context_props.tradeid}});
                        this.$root.$emit('refreshTrade');
                        break;
                    case 'purchase':
                        this.$router.push({name: "viewpo", params: {poid: context_props.purchaseid}});
                        this.$root.$emit('refreshPo');
                        break;
                    case 'sale':
                        this.$router.push({name: "viewsale", params: {saleid: context_props.saleid}});
                        this.$root.$emit('refreshSo');
                        break;
                    case 'invoice':
                        this.$router.push({name: "viewinvoice", params: {invoiceid: context_props.invoiceid}});
                        this.$root.$emit('refreshInvoice');
                        break;
                    case 'Partner':
                        if (context_props.marketplace_id) {
                            this.$router.push({name: "alloffers"});
                        } else if (context_props.member_id) {
                            this.$router.push({
                                name: "partner-invitation",
                                params: {memberid: context_props.member_id}
                            });
                        }
                        break;

                }
            },
            async getCatalogs() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs?page=0&per_page=1000`);
                    this.catalogs = data.catalogs;
                } catch (e) {

                }
            },
            async getDids() {
                try {
                    let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=1000`);
                    this.total_dids = data.total;
                    data.dids.forEach(did => {
                        this.calls.push(this.getClaims(did.did, did.catalog ? did.catalog : null))
                    })
                } catch (e) {

                }
            },
            async getClaims(did, catalog) {
                try {
                    let {data} = await this.$identity.get(`/identity/dids/${did}/claims?page=0&per_page=1000`);
                    data.claims = data.claims.map(claim => ({
                        catalog: catalog,
                        ...claim
                    }))
                    return data.claims;
                } catch (e) {

                }
            },
            async prepareProductionData() {
                try {

                    let result = await Promise.all(this.calls);
                    result = result.filter(r => r.length > 0);
                    result.forEach(r => {
                        this.claims = [...new Set([...this.claims, ...r])];
                    });
                    this.claims.forEach(claim => {
                        let found_yield = claim.statements.find(statement => (statement.name.toLowerCase().indexOf('estimated yield') !== -1));
                        let found_period = claim.statements.find(statement => (statement.name.toLowerCase().indexOf('period') !== -1));
                        let found_year = claim.statements.find(statement => (statement.name.toLowerCase().indexOf('year') !== -1));
                        let found_name = claim.statements.find(value_chain => value_chain.name.toLowerCase().indexOf('item') !== -1);
                        if (found_yield) {
                            if (found_name && !this.production_items.includes(found_name.fact.value)) {
                                this.production_items.push(found_name.fact.value)
                            }
                            if (found_year && !this.years.includes(found_year.fact.value)) {
                                this.years.push(found_year.fact.value)
                            }
                            let catalog_found = this.catalogs.find(c => c.catalog === claim.catalog);
                            if (catalog_found && !this.catalog_names.includes(catalog_found.name)) {
                                this.catalog_names.push(catalog_found.name)
                            }
                            if(found_yield) {
                                this.total_yield += Number(found_yield.fact.value);
                            }
                            this.productions.push({
                                date: claim.created,
                                item: found_name ? found_name.fact.value : null,
                                year: found_year ? found_year.fact.value: null,
                                catalog: catalog_found ? catalog_found.name : null,
                                quantity: {
                                    x: found_period ? found_period.fact.value : null,
                                    y: found_yield ? found_yield.fact.value : null
                                },
                                unit: null
                            })
                        }

                    });
                    this.selected_production_item = this.production_items[0];
                    this.selected_year = this.years[0];
                    this.selected_catalog = this.catalog_names[0];
                    let self = this;
                    let productions = this.productions.filter(p => (p.item === self.selected_production_item && p.year === self.selected_year && p.catalog === self.selected_catalog));
                    productions = productions.sort(function (a, b) {
                        return new Date(a.date) - new Date(b.date)
                    });
                    this.series[0].data = productions.map(p => p.quantity);
                }catch (e) {
                    console.error(e)
                }
            }
        }
    }

</script>

<style scoped>
    .custom-d-flex {
        display: -webkit-box !important;
    }

    .custom-bg-success {
        background-color: #b0ffbd6e;
    }

    .custom-bg-info {
        background-color: #c3caff47;
    }

    .custom-bg-grey {
        background-color: #e4ff7775;
    }
</style>
